import type { VFC } from 'react';
import { Flex } from 'antd';
import { Card } from 'components';
import { useMeterModules } from 'api/hooks/meter-modules/useModules';
import { ModulesListFilter } from './components/Filter';
import { useModulesListFilterWithPagination } from './hooks/useModulesListFilterWithPagination';
import { ModulesTable } from './components/Table';

export const ModulesList: VFC = () => {
  // State
  const { filter, pagination, setPaginationState } = useModulesListFilterWithPagination();

  // Fetch
  const { data: modulesResponse, isFetching: isFetchingModules } = useMeterModules(
    {
      ...(filter?.search && { search: filter?.search }),
      ...(filter?.meterModels && { meterModels: filter.meterModels }),
      ...(filter?.technologies && { technologies: filter.technologies }),
      populate: ['meter_models'],
      sort: filter?.sort,
      page: pagination.current,
      pageSize: pagination.pageSize,
    },
    {
      onSuccess: data => {
        setPaginationState({ total: data?.meta?.pagination?.total });
      },
    },
  );

  return (
    <Flex vertical gap={16}>
      <Card>
        <ModulesListFilter />
      </Card>

      <Card>
        <ModulesTable addonsData={modulesResponse?.data ?? []} isFetchingAddons={isFetchingModules} />
      </Card>
    </Flex>
  );
};
